import {
  fetchNotificationList,
  fetchUnreadNotificationCount,
  markAllNotificationsRead,
  markNotificationReadById,
} from "../api/notifications";
import {
  NOTIFICATION_FILTER_ALL,
  NOTIFICATION_FILTER_SET,
  NOTIFICATION_FILTER_UNREAD,
  NOTIFICATION_LIST_APPEND_SUCCESS,
  NOTIFICATION_LIST_FAIL,
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST_RESET,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_MARK_ALL_READ_FAIL,
  NOTIFICATION_MARK_ALL_READ_REQUEST,
  NOTIFICATION_MARK_ALL_READ_SUCCESS,
  NOTIFICATION_MARK_READ_FAIL,
  NOTIFICATION_MARK_READ_REQUEST,
  NOTIFICATION_MARK_READ_SUCCESS,
  NOTIFICATION_UNREAD_COUNT_FAIL,
  NOTIFICATION_UNREAD_COUNT_REQUEST,
  NOTIFICATION_UNREAD_COUNT_SUCCESS,
} from "./notificationConstants";

const buildListParams = (filter, page) => {
  const params = {};
  if (filter === NOTIFICATION_FILTER_UNREAD) {
    params.is_read = false;
  }
  if (page != null) {
    params.page = page;
  }
  return params;
};

const normalizeListResponse = (data) => {
  if (Array.isArray(data)) {
    return {
      items: data,
      count: data.length,
      next: null,
      previous: null,
    };
  }
  return {
    items: data?.results ?? [],
    count: Number(data?.count) || 0,
    next: data?.next ?? null,
    previous: data?.previous ?? null,
  };
};

const nextListGeneration = (state) => (state?.listGeneration || 0) + 1;

export const setNotificationFilter = (filter) => ({
  type: NOTIFICATION_FILTER_SET,
  payload: filter,
});

export const listNotifications = (filter = NOTIFICATION_FILTER_ALL) => async (dispatch, getState) => {
  const generation = nextListGeneration(getState().notifications);
  try {
    dispatch({
      type: NOTIFICATION_LIST_REQUEST,
      meta: { filter, append: false, generation },
    });

    const data = await fetchNotificationList(buildListParams(filter));
    const normalized = normalizeListResponse(data);

    dispatch({
      type: NOTIFICATION_LIST_SUCCESS,
      meta: { filter, generation },
      payload: normalized,
    });
  } catch (error) {
    dispatch({
      type: NOTIFICATION_LIST_FAIL,
      meta: { generation },
      payload:
        error.response && error.response.data && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const loadMoreNotifications = () => async (dispatch, getState) => {
  const state = getState().notifications || {};
  const nextPage = (state.page || 1) + 1;
  const filter = state.filter || NOTIFICATION_FILTER_ALL;
  const generation = state.listGeneration || 0;

  if (!state.next || state.loadingMore || state.loading) {
    return;
  }

  try {
    dispatch({
      type: NOTIFICATION_LIST_REQUEST,
      meta: { filter, append: true, generation, page: nextPage },
    });

    const data = await fetchNotificationList(buildListParams(filter, nextPage));
    const normalized = normalizeListResponse(data);

    dispatch({
      type: NOTIFICATION_LIST_APPEND_SUCCESS,
      meta: { filter, page: nextPage, generation },
      payload: normalized,
    });
  } catch (error) {
    dispatch({
      type: NOTIFICATION_LIST_FAIL,
      payload:
        error.response && error.response.data && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      meta: { append: true, generation },
    });
  }
};

export const resetNotifications = () => ({ type: NOTIFICATION_LIST_RESET });

export const fetchNotificationUnreadCount = () => async (dispatch) => {
  try {
    dispatch({ type: NOTIFICATION_UNREAD_COUNT_REQUEST });
    const data = await fetchUnreadNotificationCount();
    const count = Number(data?.unread_count) || 0;
    dispatch({
      type: NOTIFICATION_UNREAD_COUNT_SUCCESS,
      payload: count,
    });
  } catch (error) {
    dispatch({
      type: NOTIFICATION_UNREAD_COUNT_FAIL,
      payload:
        error.response && error.response.data && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const markNotificationRead = (id, options = {}) => async (dispatch, getState) => {
  if (id == null) return;

  dispatch({
    type: NOTIFICATION_MARK_READ_REQUEST,
    meta: { id },
  });

  try {
    const updated = await markNotificationReadById(id, options);

    dispatch({
      type: NOTIFICATION_MARK_READ_SUCCESS,
      meta: { id },
      payload: updated,
    });

    const filter = getState().notifications?.filter;
    if (filter === NOTIFICATION_FILTER_UNREAD) {
      await dispatch(listNotifications(NOTIFICATION_FILTER_UNREAD));
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_MARK_READ_FAIL,
      meta: { id },
      payload:
        error.response && error.response.data && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};

export const markAllNotificationsReadAction = () => async (dispatch, getState) => {
  dispatch({ type: NOTIFICATION_MARK_ALL_READ_REQUEST });

  try {
    await markAllNotificationsRead();
    dispatch({ type: NOTIFICATION_MARK_ALL_READ_SUCCESS });

    const filter = getState().notifications?.filter;
    if (filter === NOTIFICATION_FILTER_UNREAD) {
      await dispatch(listNotifications(NOTIFICATION_FILTER_UNREAD));
    }
  } catch (error) {
    dispatch({
      type: NOTIFICATION_MARK_ALL_READ_FAIL,
      payload:
        error.response && error.response.data && error.response.data.detail
          ? error.response.data.detail
          : error.message,
    });
  }
};
